import React from 'react';
import { FlatList } from 'react-native';
import { Paragraph, Title } from 'react-native-paper';
import { Trans } from '@lingui/macro';

import Divider from '@src/components/Divider';
import JourneyCard from '@src/components/JourneyCard';
import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  journeyNumColumns,
} from '@src/configuration/constants';
import useCollectionJourneys from '@src/hooks/useCollectionJourneys';
import { Collection, Journey } from '@src/types';

import Primes from './Primes';
import { Content, ContentWrapper, Cover } from './styled';
import styles from './styles';

type Props = {
  collection?: Collection;
};

const Component: React.FC<Props> = ({ collection }) => {
  const { data, handleEndReached } = useCollectionJourneys(
    collection?.id,
    collection?.journeys
  );

  return (
    <>
      {collection?.cover && <Cover source={collection.cover} />}
      <Content>
        <ContentWrapper>
          <Title>{collection?.title}</Title>
          <Paragraph>{collection?.description}</Paragraph>
        </ContentWrapper>
        <Primes data={collection?.primes} />
        <Primes data={collection?.immigrationGuides} isImmigration={true} />
        {collection?.journeys && collection.journeys.length !== 0 && (
          <>
            <ContentWrapper>
              <Separator />
              <Divider />
              <Separator />
              <Title>
                <Trans>Collection journeys</Trans>
              </Title>
            </ContentWrapper>
            {collection.journeys.length < 7 ? (
              <ContentWrapper>
                <FlatList<Journey>
                  key="short_journey"
                  data={data}
                  renderItem={({ item }) => <JourneyCard item={item} />}
                  ItemSeparatorComponent={Separator}
                  columnWrapperStyle={styles.columnWrapper}
                  style={styles.list}
                  numColumns={journeyNumColumns}
                  scrollEnabled={false}
                  keyExtractor={idKeyExtractor}
                />
              </ContentWrapper>
            ) : (
              <FlatList<Journey>
                key="long_journey"
                data={data}
                renderItem={({ item }) => <JourneyCard item={item} />}
                ItemSeparatorComponent={Separator}
                contentContainerStyle={styles.horizontalContentContainer}
                keyExtractor={idKeyExtractor}
                horizontal
                showsHorizontalScrollIndicator={false}
                onEndReached={handleEndReached}
              />
            )}
          </>
        )}
        {collection?.posts.length !== 0 && (
          <ContentWrapper>
            <Separator />
            <Divider />
            <Separator />
            <Title>
              <Trans>Collection posts</Trans>
            </Title>
          </ContentWrapper>
        )}
      </Content>
    </>
  );
};

Component.displayName = 'ListHeaderComponent';

export default Component;
